import { z } from 'zod'

export const contactSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(200, 'Name must be less than 200 characters'),
  email: z
    .email('Invalid email format')
    .max(200, 'Email must be less than 200 characters'),
  subject: z
    .string()
    .max(300, 'Subject must be less than 300 characters')
    .optional(),
  message: z
    .string()
    .min(1, 'Message is required')
    .max(5000, 'Message must be less than 5000 characters'),
})

export type ContactFormData = z.infer<typeof contactSchema>
